import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _isFunction from "lodash/isFunction";
import React from 'react';
import { MfComponent, setComponent } from "./MfComponent";
/**
 * 如果 卡片存在 则加载卡片
 * 否则 返回 null
 * @param cardCode
 * @return {Promise<null|*>}
 */

export function loadCardAsync(_x) {
  return _loadCardAsync.apply(this, arguments);
}
function _loadCardAsync() {
  _loadCardAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cardCode) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (cardCode) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", null);
          case 2:
            return _context.abrupt("return", function (props) {
              return React.createElement(MfComponent, _objectSpread(_objectSpread({}, props), {}, {
                packageName: '_hzero_layout_cards',
                comp: cardCode
              }));
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadCardAsync.apply(this, arguments);
}
export function setCard(cardConfig) {
  var c = cardConfig.component;
  if (_isFunction(c)) {
    c = {
      loader: c
    };
  }
  setComponent('_hzero_layout_cards', cardConfig.code, c);
}
if (process.env.NODE_ENV === 'development') {
  window.setCard = setCard;
}